export let ExistingAccountActionTypes;
(function (ExistingAccountActionTypes) {
  ExistingAccountActionTypes["AccountsRequested"] = "[Existing Accounts] Requested";
  ExistingAccountActionTypes["AccountsFetched"] = "[Existing Accounts] Fetched";
  ExistingAccountActionTypes["AccountsFetchedFailed"] = "[Existing Accounts] Fetched Failed";
  ExistingAccountActionTypes["HubsFailedToLoad"] = "[Existing Accounts] Hubs Failed To Load";
})(ExistingAccountActionTypes || (ExistingAccountActionTypes = {}));